import { Box, Tooltip } from "@mui/material";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";

/**
 * Compact icon indicator for family deductibles.
 * When isPending is true, the icon turns amber to signal an unconfirmed family link.
 */
export const FamilyDeductibleChip = ({ isPending = false }: { isPending?: boolean }) => (
  <Tooltip title={isPending ? "Family deductible — link pending confirmation" : "Family deductible applied"} arrow>
    <Box component="span" display="inline-flex" alignItems="center">
      <FamilyRestroomIcon sx={{ fontSize: 15, color: isPending ? "warning.main" : "primary.main" }} />
    </Box>
  </Tooltip>
);
